<template>
  <v-row>
    <v-col cols="12" class="py-0 d-flex flex-column justify-center align-center">
      <p class="h4 mt-4">Starting something Amazing</p>
      <v-progress-circular indeterminate size="64" width="6" color="primary" />
      <p class="pt-4 h4">This will only take a moment!</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'InstallationProgress',
}
</script>
